import React, {CSSProperties} from 'react';
import MaximumRow from './Table/TableMaximumRowSnackBar';

type PageLimitSnackbarProps = {
  index: number;
  style: CSSProperties;
  maxPage: boolean;
  maxOpen: boolean;
  RECORDS_PER_PAGE: number;
  PAGE_LIMIT: number;
  onCloseMax: any;
  onCloseWarning: any;
  warningOpen: any;
  infoRow: JSX.Element;
  isMobile: boolean;
};

const PageLimitSnackbar = (props: PageLimitSnackbarProps) => {
  return props.maxPage && props.index === props.RECORDS_PER_PAGE * props.PAGE_LIMIT ? (
    <MaximumRow
      open={props.maxOpen}
      style={props.style}
      isMobile={props.isMobile}
      handleChange={props.onCloseMax}
      severity="error"
      msg="We are unable to display any more records. Please use the Search Filters to narrow down your search results."
      autoHide={false}
    />
  ) : (
    <React.Fragment>
      {props.index === props.RECORDS_PER_PAGE * (props.PAGE_LIMIT - 1) && (
        <MaximumRow
          open={props.warningOpen}
          style={props.style}
          isMobile={props.isMobile}
          handleChange={props.onCloseWarning}
          severity="warning"
          msg="You are about to exceed the amount of viewable records. Remember to use the Search Filters at the top of each column for better results!"
          autoHide={true}
        />
      )}
      {props.infoRow}
    </React.Fragment>
  );
};

export default PageLimitSnackbar;
